import { Button, ButtonProps } from "@mui/material";

type Props = Omit<ButtonProps, "type" | "loading"> & {
  /** From useSubmitAction: disables the button and shows a spinner while the request runs. */
  submitting: boolean;
};

/** Form submit button that can't be clicked again while the submit is in progress. Use with useSubmitAction. */
export const SubmitButton = ({ submitting, children = "Submit", variant = "contained", ...rest }: Props) => (
  <Button type="submit" variant={variant} loading={submitting} {...rest}>
    {children}
  </Button>
);
